import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const Topic = RepositoryFactory.get("topic");
export default {
  CreateTopic({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Topic.CreateTopic(payload);

        commit("CREATE_COURSE", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  GetTopicByTopicId({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Topic.GetTopicByTopicId(payload);

        commit("GET_TOPIC_BY_CHAPTERID", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSingleCourse({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await course.getSingleCourse(payload);

        commit("GET_SINGLE_COURSE", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateCourse({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await course.updateCourse(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteTopic({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Topic.deleteTopic(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
